export class AppSettings {
  //public static API_ENDPOINT = 'http://localhost:5001/api/';

  public static baseUrl() {
    let base = '';

    if (window.location.origin)
      base = window.location.origin;
    else
      base = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

    return base.replace(/\/$/, '') + "/api/";
  }
}

//
